<div class="modal-root-mobile-full">
  <modal-header
    [title]="pageTitle"
    [showBackButton]="!data.isInWizard"
    [enableTooltip]="false"
    [tooltipInfo]="'creationOptionsTooltip' | i18n"
    (onBackClicked)="backToAccountCreateMain()"
  >
  </modal-header>

  <div class="modal-body">
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-6">
      <div class="tw-flex tw-flex-col tw-gap-6 tw-w-full">
        <app-signal-glow-wrapper
          adjustmentClasses="tw-rounded-2xl"
          [isSignal]="signalGlowService.isSignal()"
        >
          <ng-container
            *ngTemplateOutlet="
              syncOption;
              context: {
                title: fetchAutomaticallyTitle,
                description: fetchAutomaticallyDescription,
                icon: 'fetch-automatically',
                onClick: createByLinking.bind(this),
              }
            "
          ></ng-container>
        </app-signal-glow-wrapper>
        @if (!hasPremiumSubscription()) {
          <div class="tw-text-base sm:tw-text-sm tw-mx-3 tw-mt-3">
            {{ "featureAvailableOnPremium" | i18n }} <br class="xs:tw-hidden" />
            Sign up or start your
            <a [routerLink]="upgradeNavigation.upgradeRoute()" (click)="data.closeDialog()"
              >free trial</a
            >
            now.
          </div>
        }
      </div>

      <ng-container
        *appRoleScope="'GLOSS'"
        [ngTemplateOutlet]="syncOption"
        [ngTemplateOutletContext]="{
          title: addManuallyTitle,
          description: addManuallyDescription,
          icon: 'add-manually',
          onClick: createManually.bind(this),
        }"
      ></ng-container>
    </div>
  </div>
</div>

<ng-template
  #syncOption
  let-title="title"
  let-description="description"
  let-icon="icon"
  let-onClick="onClick"
>
  <div
    class="tw-flex tw-items-center tw-justify-center tw-p-8 tw-gap-8 tw-rounded-2xl tw-shadow-card-elevated dark:!tw-shadow-elevation-card tw-cursor-pointer tw-my-2"
    (click)="onClick()"
  >
    <div class="tw-flex tw-flex-col tw-gap-2">
      <span class="tw-font-semibold tw-text-[16px] tw-leading-tight tw-tracking-normal">{{
        title
      }}</span>
      <span
        class="tw-text-left tw-text-[14px] tw-font-medium tw-leading-none tw-tracking-[0.004em] tw-text-dt-text-tertiary"
        >{{ description }}</span
      >
    </div>
    <div
      class="tw-rounded-2xl tw-shadow-dropdown tw-w-[48px] tw-h-[48px] tw-flex tw-items-center tw-justify-center"
    >
      <icon [name]="icon" [sizeArbitrary]="'24px'"></icon>
    </div>
  </div>
</ng-template>
